<template>
  <v-menu :close-on-content-click="false" max-height="50vh" max-width="400" offset-y bottom right>
    <v-btn slot="activator" small :color="themes.client.light.primaryActionButton">
      <v-icon small left>mdi-folder</v-icon>Documents
    </v-btn>
    <v-card>
      <v-list dense class="pb-3">
        <template v-for="(document, i) in documents">
          <v-subheader v-if="document.header" :key="`${i}-header`">
            {{ document.header }}
          </v-subheader>

          <v-divider v-else-if="document.divider" :inset="document.inset" :key="`${i}-divider`" />

          <DocumentPreview v-else :file="document.file" :title="document.title">
            <v-list-tile
              slot="activator"
              slot-scope="{ toggle }"
              :key="`${i}-title`"
              @click="toggle()"
              target="blank"
            >
              <v-list-tile-avatar>
                <v-icon :color="document.color">{{ document.icon }}</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content v-if="typeof document.file === 'object'" class="black--text">
                {{ document.title }}
              </v-list-tile-content>
              <v-list-tile-content v-else :key="`${i}-has-file`" class="black--text">
                Has documentation for {{ document.title }}
              </v-list-tile-content>

              <v-list-tile-action>
                <Flag icon v-if="document.flag" :value="document.flag" />
              </v-list-tile-action>
            </v-list-tile>
          </DocumentPreview>
        </template>
        <v-subheader v-if="!documents[0]">No documents available</v-subheader>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
// Components
import DocumentPreview from '@/components/candidate/DocumentPreview'
import Flag from '@/components/candidate/flags/Flag'

// Helpers
import _ from 'lodash'
import { byEndsAt, byLevels } from '@/sorting/ProfileQualification'

export default {
  components: { DocumentPreview, Flag },

  props: { profile: { type: Object, required: true }, profileQualifications: Array },

  computed: {
    documents() {
      let documents = []

      const id = _.get(this, 'profile.identityDocument')
      if (id) {
        documents.push(
          { header: 'Personal Documents' },
          {
            icon: 'mdi-file-account',
            color: this.themes.client.light.primaryText,
            title: 'National Identification Document',
            file: id,
            flag: this.flags.find(f => RegExp('identity_document', 'gi').test(f.key)),
          }
        )
      }

      if (this.hasQualificationDocuments) documents.push({ header: 'Qualification Documents' })
      this.qualifications.forEach((q, i) => {
        let registration = _.get(q, 'proofOfRegistration')
        let transcript = _.get(q, 'transcript')
        if (transcript) {
          documents.push({
            icon: 'mdi-file-document',
            color: this.themes.client.light.primaryText,
            title: `${q.qualificationTypeName} ${q.specialization}`,
            file: transcript,
            flag: this.flags.find(
              f => f.targetType === 'ProfileQualification' && f.targetId === q.id
            ),
            flagConfig: { filter: ['transcript'], target: { ...q, type: 'ProfileQualification' } },
          })
        } else if (registration) {
          documents.push({
            icon: 'mdi-file-document',
            color: this.themes.client.light.primaryText,
            title: `${q.qualificationTypeName} ${q.specialization}`,
            file: registration,
          })
        }
      })

      if (_.get(this, 'profile.financial.incomes[0]')) {
        documents.push({ header: 'Household Income' })
        this.profile.financial.incomes.forEach(i => {
          if (i.proof) {
            documents.push({
              icon: 'mdi-file-document',
              color: this.themes.client.light.primaryText,
              title: `${i.relationship}: ${i.typeOfProof}`,
              file: i.proof,
              flag: this.flags.find(f => f.targetType === 'HouseholdIncome' && f.targetId === i.id),
              flagConfig: {
                filter: ['household_income'],
                target: { ...i, type: 'HouseholdIncome' },
              },
            })
          }
        })
      }

      return documents
    },

    flags() {
      if (!_.get(this, 'profile.flags[0]')) return []

      return _.get(this, 'profile.flags')
    },

    hasQualificationDocuments() {
      return this.qualifications.some(q => {
        return _.get(q, 'proofOfRegistration') || _.get(q, 'transcript')
      })
    },

    qualifications() {
      if (!_.get(this, 'profileQualifications.length')) return []

      let qualifications = JSON.parse(JSON.stringify(this.profileQualifications))
      return qualifications
        .sort(byLevels({ country: this.levelsCountryMode(), asc: false }))
        .sort(byEndsAt({ asc: false }))
    },
  },

  methods: {
    levelsCountryMode() {
      let qualifications = JSON.parse(JSON.stringify(this.profileQualifications))
      const countries = qualifications
        .filter(pq => _.get(pq, 'qualification.levels[0]'))
        .reduce(
          (acc, { qualification: { levels } }) => acc.concat(levels.map(l => l.countryCode)),
          []
        )
      return countries[0] ? mode(countries) : null
    },
  },
}
</script>
